import React from 'react';
import Heading from '../../components/header';
import PopupNotificationContainer from '../../container/popupNotificationContainer';
import {
    useCreatePopupMutation,
    useGetPopupListQuery,
    useGetImageLinkMutation,
} from './popupApiSlice';
import useApiLoadingOverlay from '../../hooks/useApiLoadingOverlay';
import { useDispatch } from 'react-redux';

const PopupNotificationPage = () => {
    const dispatch = useDispatch();

    const {
        data,
        isLoading: isListLoading,
        isFetching,
    } = useGetPopupListQuery();

    const [createPopup, { isLoading: isCreating }] = useCreatePopupMutation();
    const [getImageLink, { isLoading: isUploading }] = useGetImageLinkMutation();

    useApiLoadingOverlay(
        [isCreating, isListLoading, isUploading],
        dispatch
    );

    return (
        <>
            <Heading
                text="Popup Notifications"
                path="#"
                isFilterShow={false}
                isGraphShow={false}
            />
            <PopupNotificationContainer
                createPopup={createPopup}
                getImageLink={getImageLink}
                isLoading={isCreating || isUploading}
                data={data}
            />

        </>
    );
};

export default PopupNotificationPage;
